export const DrugUsageList = [
	'هر ۶ ساعت یک‌عدد',
	'هر ۸ ساعت یک‌عدد',
	'هر ۱۲ ساعت یک‌عدد',
	'روزی یک‌بار',
	'روزی ۲ بار',
	'روزی ۳ بار تا ۳ روز ، روزی ۲ بار تا ۳ روز ، روزی یک‌بار تا ۳ روز',
	'روزی ۳ بار تا ۵ روز ، روزی ۲ بار تا ۵ روز ، روزی یک‌بار تا ۵ روز',
	'شب‌ها',
	'یک شب در میان',
	'هفته ای دو بار عضلانی',
	'عضلانی تزریق شود',
	'تزریق توسط پزشک',
	'روزها'
];
